export const events = [{
    id: 1,
    title: 'Muir Woods',
    description: 'Garbage pickup',
    date: '2019-08-19T12:59-0500',
    lat: 37.8970,
    lng: -122.5811,
    fileName: 'yes.pdf'
}, {
    id: 2,
    title: 'Stinson Beach',
    description: 'beach cleanup',
    date: '2019-07-21T12:59-0500',
    lat: 37.9005,
    lng: -122.6444,
    fileName: 'yes.pdf'
}, {
    id: 3,
    title: 'Baker Beach',
    description: 'Fundraiser',
    date: '2019-08-02T12:59-0500',
    lat: 37.7936,
    lng: -122.4836,
    fileName: 'yes.pdf'
}, {
    id: 4,
    title: 'Ocean Beach',
    description: 'Dolphin Party',
    date: '2019-07-04T12:59-0500',
    lat: 32.7495,
    lng: -117.2470,
    fileName: 'yes.pdf'
}, {
    id: 5,
    title: 'Galvanize',
    description: 'Trash PickUp',
    date: '2019-06-12T12:59-0500',
    lat: 37.7877012,
    lng: -122.3970631,
    fileName: 'yes.pdf'
}]